/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkCancelRequestCancelledReason } from './bulkCancelRequestCancelledReason';

/**
 * Bulk cancel (stop) — optional shared ``cancelled_reason``.
 */
export interface BulkCancelRequest {
  /**
     * @minItems 1
     * @maxItems 200
     */
  enrollment_ids: string[];
  cancelled_reason?: BulkCancelRequestCancelledReason;
}
